export const TZ = "Europe/Budapest";
export const SLOTS = Array.from({ length: 12 }, (_, i) => i);

const tzOffset = (t, tz) => {
  const d = new Date(t);
  return Date.parse(d.toLocaleString("en-US", { timeZone: tz })) - Date.parse(d.toLocaleString("en-US", { timeZone: "UTC" }));
};

export function budapestNow() {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: TZ, weekday: "short", hour: "numeric", hourCycle: "h23", year: "numeric", month: "numeric", day: "numeric" })
    .formatToParts(new Date()).map((x) => [x.type, x.value]));
  const day = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].indexOf(p.weekday);
  return { day, slot: Math.floor(Number(p.hour) / 2), y: Number(p.year), m: Number(p.month) - 1, d: Number(p.day) };
}

// Real instant of a Budapest weekday/slot in the current week
export function slotRange(day, slot) {
  const now = budapestNow();
  const base = Date.UTC(now.y, now.m, now.d + (day - now.day), slot * 2);
  const start = base - tzOffset(base, TZ);
  return { start: new Date(start), end: new Date(start + 2 * 3600000) };
}

export const hhmm = (date, tz) => date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false, ...(tz ? { timeZone: tz } : {}) });
export const localTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const dayNames = (lang) => Array.from({ length: 7 }, (_, i) => new Date(Date.UTC(2024, 0, 1 + i)).toLocaleDateString(lang, { weekday: "long", timeZone: "UTC" }));
